import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

/** Phone-only shortcut back to the top of long toolkit pages. */
export const BackToTop = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const f = () => setShow(window.scrollY > 1400);
    f();
    window.addEventListener("scroll", f, { passive: true });
    return () => window.removeEventListener("scroll", f);
  }, []);
  const go = () => {
    if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.2 });
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <button type="button" onClick={go} aria-label="Back to top" data-testid="back-to-top"
      className={`no-print fixed bottom-[max(1rem,env(safe-area-inset-bottom))] right-4 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-ink text-paper shadow-lg transition-[opacity,transform] duration-300 lg:hidden ${show ? "opacity-100" : "pointer-events-none translate-y-4 opacity-0"}`}>
      <ArrowUp size={20} aria-hidden />
    </button>
  );
};
